// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(1200px 700px at 10% 10%, rgba(96, 165, 250, 0.18), transparent 55%),
    radial-gradient(900px 600px at 90% 30%, rgba(99, 102, 241, 0.16), transparent 55%),
    var(--mrt-bg);
  padding: 20px;
}

.login-box {
  background: var(--mrt-surface);
  color: var(--mrt-text);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  padding: 50px;
  max-width: 450px;
  width: 100%;
  animation: slideIn 0.5s ease-out;
  border: 1px solid var(--mrt-border);
  position: relative;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-header h1 {
  font-size: 2.5rem;
  color: var(--mrt-text);
  margin-bottom: 10px;
  font-weight: 700;
  letter-spacing: -1px;
}

.login-header p {
  color: var(--mrt-muted);
  font-size: 1rem;
  margin: 0;
}

.login-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.login-content > div:first-child {
  display: flex;
  justify-content: center;
  width: 100%;
}

.login-info {
  background: var(--mrt-surface-2);
  padding: 20px;
  border-radius: 10px;
  border-left: 4px solid var(--mrt-primary);
  width: 100%;
  border: 1px solid var(--mrt-border);
}

.login-info p {
  margin: 8px 0;
  font-size: 0.9rem;
  color: var(--mrt-text-2);
  line-height: 1.5;
}

.login-info p:first-child {
  font-weight: 600;
  color: var(--mrt-primary);
}

.login-theme-toggle {
  position: absolute;
  top: 14px;
  right: 14px;
  display: inline-flex;
  gap: 6px;
  align-items: center;
}

.login-theme-btn {
  height: 30px;
  padding: 0 10px;
  border-radius: 999px;
  border: 1px solid var(--mrt-border);
  background: var(--mrt-surface-2);
  color: var(--mrt-text);
  font-weight: 900;
  font-size: 12px;
  cursor: pointer;
}

.login-theme-btn.active {
  background: var(--mrt-primary);
  color: var(--mrt-primary-contrast);
  border-color: rgba(0, 0, 0, 0.12);
}

/* 반응형 디자인 */
@media (max-width: 600px) {
  .login-box {
    padding: 30px 20px;
  }

  .login-header h1 {
    font-size: 2rem;
  }

  .login-header p {
    font-size: 0.9rem;
  }
}



`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;;iBAEe;EACf,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mCAAmC;EACnC,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA,YAAY;AACZ;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".login-container {\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: radial-gradient(1200px 700px at 10% 10%, rgba(96, 165, 250, 0.18), transparent 55%),\n    radial-gradient(900px 600px at 90% 30%, rgba(99, 102, 241, 0.16), transparent 55%),\n    var(--mrt-bg);\n  padding: 20px;\n}\n\n.login-box {\n  background: var(--mrt-surface);\n  color: var(--mrt-text);\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  padding: 50px;\n  max-width: 450px;\n  width: 100%;\n  animation: slideIn 0.5s ease-out;\n  border: 1px solid var(--mrt-border);\n  position: relative;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.login-header h1 {\n  font-size: 2.5rem;\n  color: var(--mrt-text);\n  margin-bottom: 10px;\n  font-weight: 700;\n  letter-spacing: -1px;\n}\n\n.login-header p {\n  color: var(--mrt-muted);\n  font-size: 1rem;\n  margin: 0;\n}\n\n.login-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 30px;\n}\n\n.login-content > div:first-child {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.login-info {\n  background: var(--mrt-surface-2);\n  padding: 20px;\n  border-radius: 10px;\n  border-left: 4px solid var(--mrt-primary);\n  width: 100%;\n  border: 1px solid var(--mrt-border);\n}\n\n.login-info p {\n  margin: 8px 0;\n  font-size: 0.9rem;\n  color: var(--mrt-text-2);\n  line-height: 1.5;\n}\n\n.login-info p:first-child {\n  font-weight: 600;\n  color: var(--mrt-primary);\n}\n\n.login-theme-toggle {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  display: inline-flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.login-theme-btn {\n  height: 30px;\n  padding: 0 10px;\n  border-radius: 999px;\n  border: 1px solid var(--mrt-border);\n  background: var(--mrt-surface-2);\n  color: var(--mrt-text);\n  font-weight: 900;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.login-theme-btn.active {\n  background: var(--mrt-primary);\n  color: var(--mrt-primary-contrast);\n  border-color: rgba(0, 0, 0, 0.12);\n}\n\n/* 반응형 디자인 */\n@media (max-width: 600px) {\n  .login-box {\n    padding: 30px 20px;\n  }\n\n  .login-header h1 {\n    font-size: 2rem;\n  }\n\n  .login-header p {\n    font-size: 0.9rem;\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
